<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <PageHeader :items="items" :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button v-b-modal.upload-modal variant="success"><i class="fa fa-upload"></i> Import Services</b-button> |
                  <b-button v-if="user_permissions.add_labservice" v-b-modal.lab-modal variant="primary"><i class="fa fa-plus"></i> New Service
                  </b-button>

                  <!--SERVICE EXCEL UPLOAD MODAL-->
                  <b-modal
                      id="upload-modal"
                      ref="modal"
                      hide-footer
                      title="Upload an excel file of service"
                      @hidden="resetUploadModal"
                  >
                    <div class="mb-2">
                      <label class="col-form-label" for="upload-file"
                      >Select file to upload:</label
                      >
                      <input
                          id="upload-file"
                          class="form-control"
                          type="file"
                          ref="file"
                          @change="handleUpload"
                      />
                    </div>
                    <div class="modal-footer">
                      <button
                          class="btn btn-secondary"
                          @click="$bvModal.hide('upload-modal')"
                          type="button"
                      >
                        Close
                      </button>
                      <button class="btn btn-primary" type="button" @click="importFile('upload-modal')">
                        Import Services
                        <b-spinner
                            v-if="is_uploading"
                            variant="light"
                            small
                            role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>

                  <!-- ADDING NEW SERVICE MODAL-->
                  <b-modal id="lab-modal" ref="modal" hide-footer title="Add New Service"
                           @hidden="resetAddModal">
                    <form ref="form" @submit.stop.prevent="saveService">
                    <div class="form-group mb-3" v-if="branch_id == 0">
                      <label>Select Branch</label>
                      <select                       
                        v-model="data.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                      <div class="text-danger" v-if="branchError">
                        <em>{{ branchError }}</em>
                      </div>
                    </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-name">Service Name:</label>
                        <input id="service-name" v-model="data.name" class="form-control" required type="text"
                               @keyup="checkName" placeholder="E.g Blood Smear">
                        <div class="text-danger" v-if="nameError">
                          <em>{{nameError}}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label">Service Category:</label>
                        <model-list-select :list="this.labCategories ? this.labCategories : []" v-model="data.category" option-value="id" option-text="categoryName" placeholder="Select Service Category">
                        </model-list-select>
                        <div class="text-danger" v-if="categoryError">
                          <em>{{categoryError}}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-cost">Service Cost:</label>
                        <input id="service-cost" @keyup="addComma" v-model="data.cost" class="form-control" required type="text" placeholder="E.g 4,000">
                        <div class="text-danger" v-if="costError">
                          <em>{{costError}}</em>
                        </div>
                        <div class="text-info">
                          <em>What it cost a facility to do this service (Buying price)</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-price">Service Price:</label>
                        <input id="service-price" v-model="data.price" class="form-control" required
                               type="text" @keyup="addComma" placeholder="E.g 5,500">
                        <div class="text-danger" v-if="priceError">
                          <em>{{priceError}}</em>
                        </div>
                        <div class="text-info">
                          <em>What clients pay for this service (Selling price)</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label">Result Type:</label>
                        <model-list-select :list="this.resultTypes ? this.resultTypes : []" v-model="data.type" option-value="id" option-text="name" placeholder="Select Result Type ">
                        </model-list-select>
                        <div class="text-danger" v-if="typeError">
                          <em>{{typeError}}</em>
                        </div>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button class="btn btn-secondary"  @click="$bvModal.hide('lab-modal')" type="button">Close</button>
                      <button v-if="existingServices.length" class="btn btn-info" disabled title="This Service already exists"
                              type="button"><i class="fa fa-ban"></i> Save Service
                      </button>
                      <button v-else class="btn btn-primary" type="button" @click="handleAddModal">Save Service</button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        :options="pageOptions"
                        class="form-select form-select-sm"
                        size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        class="form-control form-control-sm ms-2"
                        placeholder="Search..."
                        type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :current-page="currentPage"
                  :fields="fields"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :items="this.labServices"
                  :per-page="perPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  bordered
                  class="datatables"
                  responsive="sm"
                  @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(sample)="data">
                  <table>
                    <tbody>
                    <tr v-for="(sample, s) in data.item.samples" :key="s">{{sample.testsample.sample}}</tr>
                    </tbody>
                  </table>
                  
                </template>
                    <template #cell(resultType)="data">
                  <span v-if="data.item.resultType == 1">Has Defined Result Options</span>
                  <span v-else-if="data.item.resultType == 2">Has Undefined Result Options</span>
                  <span v-else-if="data.item.resultType == 3">Has Machine Based Results</span>
                  <span v-else-if="data.item.resultType == 4">Has Defined Parameters</span>
                  <span v-else-if="data.item.resultType == 5">Has Culture and Sensitivity</span>
                  <span v-else>--</span>
                     </template>
                <template #cell(action)="data">
          
                  <!-- Edit Modal -->
                  <b-button v-if="user_permissions.edit_labservice"
                      v-b-modal.edit-modal
                      size="sm"
                      variant="primary"
                      @click="showEditModal(data)"><i class="fa fa-edit"></i> Edit
                  </b-button>
                  <b-button v-else
                  disabled
                      v-b-modal.edit-modal
                      size="sm"
                      variant="primary"
                      @click="showEditModal(data)"><i class="fa fa-edit"></i> Edit
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button v-if="user_permissions.delete_labservice"
                      v-b-modal.delete-modal
                      size="sm"
                      variant="danger"
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i> Delete
                  </b-button>
                  <b-button v-else
                  disabled
                      v-b-modal.delete-modal
                      size="sm"
                      variant="danger"
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i> Delete
                  </b-button>
                  |
                  <!-- Sample Modal -->
                  <b-button v-if="user_permissions.add_labservice_sample" v-b-modal.sample-modal size="sm" variant="success" @click="showSampleModal(data)"><i class="fa fa-plus"></i> Sample
                  </b-button>
                  |
                  <!-- Consumables Modal -->
                  <b-button v-b-modal.consumable-modal size="sm" variant="secondary" @click="consumableModal(data)"><i class="fa fa-plus"></i> consumables
                  </b-button>
                </template>
              </b-table>
              <h3 v-if="!this.labServices" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
            </div>

            <!-- EDITING SERVICE MODAL-->
            <b-modal id="edit-modal" centered ref="modal" hide-footer :title="editData.name"
                     @hidden="resetEditModal">
              <form ref="form" @submit.stop.prevent="saveChanges">
              <div class="form-group mb-3" v-if="branch_id == 0">
                <label>Select Branch</label>
                <select                       
                  v-model="editData.branch_id"
                  class="form-control"                      
                >
                  <option value="All">All</option>
                  <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                </select>
                <div class="text-danger" v-if="branchError">
                  <em>{{ branchError }}</em>
                </div>
              </div>
                <div class="mb-3">
                  <label class="col-form-label" for="name">Service Name:</label>
                  <input id="name" v-model="editData.name" @keyup="checkName" class="form-control" type="text">
                  <div class="text-danger" v-if="nameError">
                    <em>{{nameError}}</em>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="col-form-label">Service Category:</label>
                  <model-list-select :list="this.labCategories ? this.labCategories : []" v-model="editData.category" option-value="id" option-text="categoryName" placeholder="Change Service Category">
                  </model-list-select>
                  <div class="text-danger" v-if="categoryError">
                    <em>{{categoryError}}</em>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="col-form-label" for="cost">Service Cost:</label>
                  <input id="cost" @keyup="addComma" v-model="editData.cost" class="form-control" type="text">
                  <div class="text-danger" v-if="costError">
                    <em>{{costError}}</em>
                  </div>
                  <div class="text-info">
                    <em>What it cost a facility to do this service (Buying price)</em>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="col-form-label" for="price">Service Price:</label>
                  <input id="price" v-model="editData.price" class="form-control" type="text" @keyup="addComma" >
                  <div class="text-danger" v-if="priceError">
                    <em>{{priceError}}</em>
                  </div>
                  <div class="text-info">
                    <em>What clients pay for this service (Selling price)</em>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="col-form-label" for="type">Change Result Type:</label>
                  <select id="type" v-model="editData.type" class="form-control">
                    <option value="1">Has Defined Result Options</option>
                    <option value="2">Has Undefined Result Options</option>
                    <option value="3">Has Machine Based Results</option>
                    <option value="4">Has Defined Parameters</option>
                    <option value="5">Has Culture and Sensitivity</option>
                  </select>
                  <div class="text-danger" v-if="typeError">
                    <em>{{typeError}}</em>
                  </div>
                </div>
              </form>
              <div class="modal-footer">
                <button class="btn btn-secondary"  @click="$bvModal.hide('edit-modal')" type="button">Close</button>
                <button v-if="existingServices.length" class="btn btn-info" disabled title="This Service already exists"
                        type="button"><i class="fa fa-ban"></i> Save Service
                </button>
                <button v-else class="btn btn-primary" type="button" @click="handleEditModal">Save Service</button>
              </div>
            </b-modal>

            <!-- DELETING SERVICE MODAL-->
            <b-modal id="delete-modal" header-bg-variant="warning" header-text-variant="light" ref="modal" size="sm" centered
                title="Confirmation Alert"
                @hidden="resetDeleteModal"
                @ok="confirmDelete"
            >
              <div class="d-block text-center">
                <h5>
                  Are you sure you want to delete <code>{{this.deleteData.name}}</code>? <br>
                  Click <code>OK</code> to continue
                </h5>
              </div>
            </b-modal>

            <!-- SAMPLE MODAL-->
            <b-modal id="sample-modal" ref="modal"  hide-footer @hidden="resetSample">
              <template #modal-title>
                <p class="text-uppercase">add {{sampleData.test}} samples</p>
              </template>
              <div class="mb-3">
                <label class="col-form-label" for="collection-date">Select samples of {{sampleData.test}}:</label>
                <multiselect
                    :height="300"
                    v-model="sampleData.samples"
                    :options="labsamples ? labsamples : []"
                    :multiple="true"
                    :taggable="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Search test sample types"
                    label="sample" @input="resetErrors"
                    track-by="sample"
                    :preselect-first="false">
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__single" v-if="values.length && values.length &amp;&amp; !isOpen">{{ values.length }} samples are selected</span>
                  </template>
                </multiselect>
                <div class="text-danger" v-if="sampleError">
                  <em>{{sampleError}}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary"  @click="$bvModal.hide('sample-modal')" type="button">Close</button>
                <button class="btn btn-primary" type="button" @click="saveSamples('sample-modal')">
                  Save sample
                  <b-spinner v-if="ServiceStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </b-modal>

            <!-- CONSUMABLE MODAL-->
            <b-modal id="consumable-modal" ref="modal"  hide-footer @hidden="resetConsumableData">
              <template #modal-title>
                <p class="text-uppercase text-truncate">{{consumableData.test}} consumables</p>
              </template>
              <div class="mb-2">
                <div v-if="test_consumables.length">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>SN</th>
                      <th>Item</th>
                      <th>Qty</th>
                      <th>Qty</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(consumable, con) in test_consumables" :key="con">
                      <td>{{con+1}}</td>
                      <td>{{consumable.consumable.name}}</td>
                      <td>{{consumable.quantity}}</td>
                      <td>
                        <button class="btn btn-danger btn-sm" title="Remove this consumable" @click="deleteItem(consumable, 'consumable-modal')"><i class="fa fa-times"></i></button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="text-center">
                  No matched consumables
                </div>
              </div>
              <div class="mb-3">
                <label class="col-form-label">New Consumable:</label>
                <model-list-select :list="this.LabItems ? this.LabItems : []" v-model="consumableData.consumable" option-value="id" option-text="itemName" placeholder="Select a Consumable">
                </model-list-select>
                <div class="text-danger" v-if="consumableError">
                  <em>{{consumableError}}</em>
                </div>
              </div>
              <div class="mb-3">
                <label class="col-form-label" for="quantity">Consumable Quantity:</label>
                <input id="quantity" v-model="consumableData.quantity" class="form-control" type="text">
                <div class="text-danger" v-if="quantityError">
                  <em>{{quantityError}}</em>
                </div>
                <div class="text-info">
                  <em>Quantity required to do this this test</em>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary"  @click="$bvModal.hide('consumable-modal')" type="button">Close</button>
                <button class="btn btn-primary" type="button" @click="saveConsumables('consumable-modal')">
                  Save consumable
                  <b-spinner v-if="ServiceStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import {mapGetters, mapActions, mapState} from "vuex";
import axios from "axios";

export default {
  page: {
    title: "Lab Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    Multiselect,
    ModelListSelect,
  },

  data() {
    return {
      title: "Lab Services",
      items: [
        {
          text: "Service Section",
          href: "#",
        },
        {
          text: "Laboratory Services",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "serviceName",
          sortable: true,
          label: "SERVICE NAME",
        },
        {
          key: "serviceCost",
          sortable: true,
          label: "COST",
        },
        {
          key: "servicePrice",
          sortable: true,
          label: "PRICE",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE & TIME",
        },
        {
          key: "sample",
          sortable: true,
          label: "SAMPLE TYPES",
        },
         {
          key: "resultType",
          sortable: true,
          label: "RESULT TYPE",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        name: "",
        branch_id: "All",
        type: "",
        cost: "",
        price: "",
        category: "",
      },
      existingServices: [],
      nameError: "",
      priceError: "",
      costError: "",
      typeError: "",
      branchError:"",
      categoryError: "",
      editData: {
        id: "",
        name: "",
        cost: "",
        price: "",
        branch_id: "",
        type: "",
        category: "",
      },
      deleteData:{
        id: "",
        name: "",
      },
      sampleData:{
        samples:"",
        id:"",
        test:"",
      },
      consumableData:{
        consumable:"",
        quantity:"",
        id:"",
        test:"",
      },
      test_consumables:[],
      file: "",
      is_uploading: false,
      modal_id:"",
      sampleError:"",
      consumableError:"",
      quantityError:"",
    };
  },

  computed: {
    ...mapGetters("services", ["labServices","resultTypes","labCategories","ServiceStatus"]),
    ...mapGetters("laboratory", ["labsamples"]),
    ...mapGetters("branch", ["GetBranch"]),
    ...mapGetters("inventory", ["LabItems"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("auth", ["user_permissions","branch_id"]),

    rows() {
      return this.labServices ? this.labServices.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.labServices ? this.labServices.length : 1;
  },
  watch: {
    notification_show(newValue) {
      if (newValue === true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype === "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchServices: "services/fetchLabServices",
      FetchCategories: "services/fetchLabCategories",
      SubmitService: "services/saveLabService",
      SubmitUpdates: "services/updateLabService",
      DeleteService: "services/deleteLabService",
      FetchSample: "laboratory/fetchLabSamples",
      MatchSamples: "services/matchTestSamples",
      MatchConsumable: "services/matchTestConsumable",
      DeleteConsumable: "services/deleteTestConsumable",
      FetchBranch: "branch/fetchBranch",
      FetchLabItem: "inventory/fetchLabItems",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    checkName() {
      //when creating a new one
      if (this.data.name !== "") {
        this.existingServices = this.labServices.filter((service) => {
          return service.serviceName.toUpperCase() === this.data.name.toUpperCase();
        });
        if (this.existingServices.length){
          this.nameError = this.data.name+" exists already";
        }else{
          this.nameError =""
        }
      } else {
        this.existingServices = [];
      }
    },

    addComma() {
      this.priceError="";
      this.costError="";
      //====================================================
      this.data.price = this.thousandSeparator(this.data.price);
      this.data.cost = this.thousandSeparator(this.data.cost);
      //====================================================
      this.editData.cost = this.thousandSeparator(this.editData.cost);
      this.editData.price = this.thousandSeparator(this.editData.price);
    },

    //===================================================
    handleAddModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.saveService()
    },

    saveService() {
      //Now validate for required fields
      if (this.data.name==""){
        this.nameError="Service name is required";
        return;
      }else {
        this.nameError=""
      }
      if (this.data.cost==""){
        this.costError="Service cost is required";
        return;
      }else {
        this.costError=""
      }
      if (this.data.price==""){
        this.priceError="Service price is required";
        return;
      }else {
        this.priceError=""
      }
      if (this.data.category==""){
        this.categoryError="Service category is required";
        return;
      }else {
        this.categoryError=""
      }
      if (this.data.type==""){
        this.typeError="Result type is required";
        return;
      }else {
        this.typeError=""
      }
      if (this.data.branch_id==""){
        this.branchError="Branch field is required";
        return;
      }else {
        this.branchError=""
      }

      // Push the data submitted to the endpoint
      this.SubmitService(this.data);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('lab-modal')
      })
    },

    //Now reset the add modal
    resetAddModal() {
      this.data.name = "";
      this.data.cost = "";
      this.data.price = "";
      this.data.type = "";
      this.data.category = "";
      this.data.branch_id = "All";
      this.nameError = "";
      this.priceError = "";
      this.costError = "";
      this.categoryError = "";
      this.typeError = "";
      this.branchError = "";
      this.existingServices = [];
    },

    //=========================================================
    showEditModal(data) {
      this.editData.id=data.item.id;
      this.editData.branch_id = data.item.branch_id;
      this.editData.name=data.item.serviceName;
      this.editData.cost=data.item.serviceCost;
      this.editData.price=data.item.servicePrice;
      this.editData.type=data.item.resultType;
      this.editData.category=data.item.category.id;
    },

    handleEditModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.saveChanges()
    },

    saveChanges() {
      //Now validate for required fields
      if (this.editData.name==""){
        this.nameError="Service name is required";
        return;
      }else {
        this.nameError=""
      }
      if (this.editData.cost==""){
        this.costError="Service cost is required";
        return;
      }else {
        this.costError=""
      }
      if (this.editData.price==""){
        this.priceError="Service price is required";
        return;
      }else {
        this.priceError=""
      }
      if (this.editData.type==""){
        this.typeError="Service price is required";
        return;
      }else {
        this.typeError=""
      }
      if (this.editData.category==""){
        this.categoryError="Service price is required";
        return;
      }else {
        this.categoryError=""
      }
      if (this.editData.branch_id==""){
        this.branchError="Branch field is required";
        return;
      }else {
        this.branchError=""
      }

      // Push the data submitted to the endpoint
      this.SubmitUpdates(this.editData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('edit-modal')
      })
    },

    resetEditModal(){
      this.editData.id="";
      this.editData.name="";
      this.editData.cost="";
      this.editData.price="";
      this.editData.type="";
      this.editData.branch_id="";
      this.editData.category="";

      this.nameError = "";
      this.priceError = "";
      this.costError = "";
      this.branchError = "";
    },

    //====================================================
    showDeleteModal(data) {
      this.deleteData.name=data.item.serviceName;
      this.deleteData.id=data.item.id;
    },
    confirmDelete(){
      // Push the data submitted to the endpoint
      this.DeleteService(this.deleteData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('delete-modal')
      })
    },
    resetDeleteModal(){
      this.deleteData.id="";
      this.deleteData.name="";
    },

    //=======================================================
    showSampleModal(test){
      this.sampleData.samples=""
      this.sampleData.test=test.item.serviceName
      this.sampleData.id=test.item.id
    },
    saveSamples(modalId){
      this.modal_id=modalId;

      if (this.sampleData.samples==""){
        this.sampleError="Please select at least one sample to continue";
        return;
      }else {
        this.sampleError="";
      }
      //dispatch to endpoint
      this.MatchSamples(this.sampleData);
    },
    resetSample(){
      this.sampleData.samples=""
      this.sampleData.test=""
      this.sampleData.id=""
      this.sampleError=""
    },

    consumableModal(test){
      this.consumableData.consumable=""
      this.consumableData.test=test.item.serviceName
      this.consumableData.id=test.item.id
      this.test_consumables=test.item.consumables
    },

    saveConsumables(modalId){
      this.modal_id=modalId;

      if (this.consumableData.consumable==""){
        this.consumableError="Please select a consumable to continue";
        return;
      }else {
        this.consumableError="";
      }

      if (this.consumableData.quantity=="" || this.consumableData.quantity < 1){
        this.quantityError="Please enter consumable quantity required to do this test";
        return;
      }else {
        this.quantityError="";
      }
      //dispatch to endpoint
      this.MatchConsumable(this.consumableData);
    },
    resetConsumableData(){
      this.consumableData.consumable=""
      this.consumableData.quantity=""
      this.consumableData.test=""
      this.consumableData.id=""
      this.consumableError=""
      this.quantityError=""
      this.test_consumables=[]
    },

    deleteItem(consumable, modalId){
      this.modal_id=modalId;
      this.DeleteConsumable(consumable.id);
    },

    resetErrors(){
      this.sampleError=""
      this.consumableError=""
    },

    //===== Upload services ================
    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    importFile(modelId) {
      this.is_uploading = true;
      let formData = new FormData();
      formData.append("file", this.file);

      const headers = { 'Content-Type': 'multipart/form-data' };
      axios.post('import_lab_services', formData, { headers }).then((res) => {
        this.is_uploading = false;
        this.closeModal(modelId);
        if (res.status == 200) {
          let message = { 'msg': 'Success upload'}
          this.FetchServices();
          this.$store.dispatch('notification/success',message);
        } else {
          let message = { 'msg': 'Something went wrong and upload failed' }
          this.$store.dispatch('notification/error',message);
        }
      }).catch(()=>{
        this.is_uploading = false;
        this.closeModal(modelId);
        let message = { 'msg': 'Something went wrong and upload failed' }
        this.$store.dispatch('notification/error',message);
      });
    },
    resetUploadModal() {},

    // CLOSE MODEL
    closeModal(modelId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modelId);
      });
    },

  },

  created() {
    this.FetchServices();
    this.FetchCategories();
    this.FetchSample();
    this.FetchBranch();
    this.FetchLabItem();
  },
};
</script>

<style lang="css" scoped>
</style>